const zh = {
    language: {
        name: 'English'
    },
    navbar: {
        home: '首页',
        introduction: '预订须知',
        cooperation: '合作加盟',
        contact: '联系我们',
        about: '关于我们',
        info1: '酒店及自游行产品交易平台',
        info2: '龙腾捷旅订房集团旗下站点',

    },
    log: {
        name: '酒店及自由行交易平台',
        system: '供应商操作系统',
        enterprise: '企业用户登录',
        user: '企业编号',
        oper: '操作员',
        pwd: '密码',
        captcha: '验证码',
        login: '登录',
        remacc: '记住账号密码',
        reg: '我要注册',
        fogpwd: '忘记密码',

        slogan1: '没有订房难，只有订房易',
        slogan2: '您想要的这儿都有',


    },
    home: {
        title: '全球酒店预订资源',
        text: '每天大量中、港、澳及海外包房酒店促销优惠! ',
        text1: '22万家港澳及国内酒店可供预订！超过30万家海',
        text2: '外酒店预订资源！15万家酒店可实时确认!',
        //		text3:' ',

        title1: '实时预订 实时确认',
        titletext1: '集产品、预订、支付、财务内部管理功能为一体。',

        title2: '数据对接 方便快捷',
        titletext2: '订房易提供标准化API数据接口，实时获取价格、库存，实',
        titletext3: '时下单实时成交。接口中提供海量产品，互联网旅游生态，',
        titletext4: "无缝对接，大量节约人力，提升效率。",

        title3: '信贷支持 财务无忧',
        titletext5: "您的生意伙伴，专享免息信用结算，龙腾捷旅强大的资金储备",
        titletext6: "为您的业务保驾护航，只为您用得更好，订的更顺。"
    },
    footer: {
        know: '了解我们',
        about: '关于我们',
        contact: '联系我们',
        suggestions: '投诉建议',
        join: '诚聘英才',

        info1: '客户须知',
        info2: '预订须知',
        info3: '协议下载',
        info4: '教程下载',

        email: '邮箱地址',
        email1: '国内酒店合作 chinahotel-1@cnbooking.net',
        email2: '国际酒店合作 globalhotel-12@cnbooking.net ',
        email3: 'OTA合作 channel@cnbooking.net',
        email4: '旅行社合作 marketing-2@cnbooking.net',

        wechat: '微信二维码',


    }
}

export default zh


// WEBPACK FOOTER //
// ./src/common/lang/zh.js